module.exports = __webpack_public_path__ + "assets/img/discernment_license_describe.809fa865.png";